export const initialFilterState = {
    users: [],
    assets: [],
    assignDrivers: [],
    scheduleWizard: [],
    locations: [],
    schedules: [],
    scheduledReports: [],
    migration: [],
    reviews: [],
    jobAmendments: [],
    jobs: [],
    completedJobs: [],
    reviewDates: {
        startDate: undefined,
        endDate: undefined
    },
    reviewLocationHierarchy: {
        list: [],
        hierarchySelected: undefined
    },
    auditingDates: {
        startDate: undefined,
        endDate: undefined
    },
    walkaroundChecks: [],
    walkaroundDates: {
        startDate: null,
        endDate: null
    },
    checks: [],
    checksTemplates: [],
    alerts: [],
    jobListingDates: {
        startDate: null,
        endDate: null
    },
    employeeAssessmentsOverview: [],
    employeeAssessmentsRisk: [],
    employeeAssessmentsUpcoming: [],
    employeeAssessments: [],
    jobListingLocation: {
        list: []
    },
    jobSearch: null,
    jobListingDatesContract: {
        startDate: null,
        endDate: null
    },
    jobListingLocationContract: {
        list: []
    },
    jobSearchContract: null,
    collisions: [],
    driverHoursDrilldown: [],
    maintenanceKpiDrilldown: [],
    externalContacts: [],
    externalContactListingLocation: {
        list: null
    },
    riskSearch: {},

    fleetSearch: null,
    assignAssociatedAssets: [],
    operatingLicenceAssets: [],
    operatingLicenceLocations: {
        locations: []
    },
    licenceChecking:[],
    licenceCheckingOnboarding: [],
    insuranceListingSearch: null,
    insuranceListingTab: 0,
    insuranceListingFilters: [],
    insuranceListingAccounts: [],
    greyFleetSearchStats: [],
    documentTypes: [],
    upcomingEvents: { list: [] },
    pcnOpenListing: [],
    pcnClosedListing: [],
    pcnListingAccounts: [],
    pcnSorting: {},
    manualEntryTemplates: [],
    eventListingFilterReduxHUB: [],
    eventListingFilterReduxPROFILE: [],
    eventSchedulesFilterReduxHUB: [],
    eventSchedulesFilterReduxPROFILE: [],
    eventTypeFilters: [],
    costListingFilterReduxHUB: [],
    costListingFilterReduxPROFILE: [],
    defectListingFilterReduxHUB: [],
    defectListingFilterReduxPROFILE: [],
    vehicleAssets: [],
}

const FilteringReducer = (state = initialFilterState, action) => {
    switch (action.type) {
        case "SET_FILTER":
            var currentState = {
                ...state
            };

            currentState[action.name] = action.payload
            return currentState;
        case "RESET_STORE":
            state = initialFilterState
            return state;
        default:
            return state;

    }
}

export default FilteringReducer;